/* tslint:disable */

/* eslint-disable */

/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from "../runtime";
import {
  ExtractionTopic,
  ExtractionTopicFromJSON,
  ExtractionTopicFromJSONTyped,
  ExtractionTopicToJSON,
} from "./ExtractionTopic";

/**
 *
 * @export
 * @interface ExtractionTopicListResponse
 */
export interface ExtractionTopicListResponse {
  /**
   *
   * @type {number}
   * @memberof ExtractionTopicListResponse
   */
  offset: number;
  /**
   *
   * @type {number}
   * @memberof ExtractionTopicListResponse
   */
  limit: number;
  /**
   *
   * @type {string}
   * @memberof ExtractionTopicListResponse
   */
  order: string;
  /**
   *
   * @type {string}
   * @memberof ExtractionTopicListResponse
   */
  sort: string;
  /**
   *
   * @type {number}
   * @memberof ExtractionTopicListResponse
   */
  count: number;
  /**
   *
   * @type {Array<ExtractionTopic>}
   * @memberof ExtractionTopicListResponse
   */
  data: Array<ExtractionTopic>;
}

export function ExtractionTopicListResponseFromJSON(
  json: any
): ExtractionTopicListResponse {
  return ExtractionTopicListResponseFromJSONTyped(json, false);
}

export function ExtractionTopicListResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ExtractionTopicListResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    offset: json["offset"],
    limit: json["limit"],
    order: json["order"],
    sort: json["sort"],
    count: json["count"],
    data: (json["data"] as Array<any>).map(ExtractionTopicFromJSON),
  };
}

export function ExtractionTopicListResponseToJSON(
  value?: ExtractionTopicListResponse | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    offset: value.offset,
    limit: value.limit,
    order: value.order,
    sort: value.sort,
    count: value.count,
    data: (value.data as Array<any>).map(ExtractionTopicToJSON),
  };
}
